import type { FilterConfigs } from '@pages/VendorsSearch/containers/FilterPills/atoms';
import { receiveFilterPills } from '@redux/search';
import searchFacets from '../../../../helpers/seo/searchFacetSeoText';
import { getCategory } from '../../category';

export function setCategoryFilters(
	filterConfigs: FilterConfigs,
	categoryCode: FilterPills.VendorCategories,
): Redux.ThunkResult<void> {
	return (dispatch, getState) => {
		const state = getState();
		const desktopLimit = 6;
		const mobileUI = state.viewport.isMobile;

		const shouldAddCategoryFilterPill = 'category' in filterConfigs;

		dispatch(
			receiveFilterPills({
				filterConfigs,
				mobileUI,
				categoryCode,
				desktopLimit,
				shouldAddCategoryFilterPill,
			}),
		);
	};
}

export function getFollowableFacets(): Redux.ThunkResult<void> {
	return (dispatch, getState) => {
		const state = getState();
		const categoryCode = getCategory(state).code;

		const followableFacets = searchFacets
			.filter((facet) => facet.category_code === categoryCode)
			.map((facet) => facet.filter_id);

		dispatch({
			type: 'filters/UPDATE_FOLLOWABLE_FACETS',
			payload: {
				followableFacets,
			},
		});
	};
}
